import { useEffect, useRef } from "react";

const EVENTS = [
  "mousemove",
  "mousedown",
  "keydown",
  "scroll",
  "touchstart",
];

export default function useIdleTimeout(timeout, onIdle, enabled) {
  const timerRef = useRef(null);

  const resetTimer = () => {
    if (!enabled) return;

    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    timerRef.current = setTimeout(() => {
      if (enabled) {
        onIdle();
      }
    }, timeout);
  };

  useEffect(() => {
    if (!enabled) {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
      return;
    }

    EVENTS.forEach(event =>
      window.addEventListener(event, resetTimer)
    );

    resetTimer();

    return () => {
      EVENTS.forEach(event =>
        window.removeEventListener(event, resetTimer)
      );
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [enabled, timeout]);
}
